import { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Dialog,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Grid,
  DialogActions,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch, useSelector } from "react-redux";
import { createDepositRequest } from "../../../redux/BullionDeposit/bullionDepositSlice";
import { RxCross2 } from "react-icons/rx";
import { toast } from "react-toastify";
import BullionDepositList from "./BullionDepositList";
import { getMetalsRequest } from "../../../redux/GetMetals/metalSlice";
import { getConfiguration } from "../../../redux/Configuration/configurationSlice";
import { canShowPermission } from "../Permissions/permissionObject";

const BullionDeposit = () => {
  const [open, setOpen] = useState(false);
  const metalState = useSelector((state) => state.metal || {});
  const data = metalState.data || {};
  const enabledMetals = data.metals || [];
   const configurationData = useSelector(
      (state) => state.appConfig.configurationData
    );
  const handleOpenDialog = () => setOpen(true);
  const handleCloseDialog = () => setOpen(false);
  const [role, setRole] = useState(""); // Metal ID
  const dispatch = useDispatch();
  const [bullionDepositStatus, setBullionDepositStatus] = useState("true");
  useEffect(() => {
      dispatch(getConfiguration());
    }, []);
  
    useEffect(() => {
      if (Object.keys(configurationData).length) {
        setBullionDepositStatus(configurationData.bulliondepositstatus === "true");
      }
    }, [configurationData]);
  const [formData, setFormData] = useState({
    planQuantity: "",
    planName: "",
    planduration: "",
    maxDuration: "",
    minQty: "",
    maxQty: "",
    interest: "",
    disclaimer: "",
  });

  const [permissions, setPermissions] = useState({});

useEffect(() => {
  const storedPermissions = localStorage.getItem("userPermissions");
  if (storedPermissions) {
    try {
      setPermissions(JSON.parse(storedPermissions));
    } catch (e) {
      console.error("Invalid permissions JSON", e);
    }
  }
}, []);

const canCreateBullionDeposit = canShowPermission(permissions, "createDepositPlan", "create");


  useEffect(() => {
    dispatch(getMetalsRequest());
  }, [dispatch]);

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };
  const handleAdd = () => {
    const { planName, planQuantity, planduration } = formData;

    if (!planName.trim()) {
      toast.error("Plan Name is required");
      return;
    }

    if (!planQuantity.trim()) {
      toast.error("Plan Quantity is required");
      return;
    }

    if (!planduration.trim()) {
      toast.error("Plan Duration is required");
      return;
    }

    if (!role) {
      toast.error("Select Metal is required");
      return;
    }

    // Don't change your original logic here
    const payload = {
      name: formData.planName,
      qty: Number(formData.planQuantity),
      bullion: role,
      duration: Number(formData.planduration),
      unit: "Days",
      interest: parseFloat(formData.interest),
      enabled: true,
      comment: formData.disclaimer,
      status: true,
    };

    dispatch(createDepositRequest(payload));
    handleCloseDialog();
  };

    if (bullionDepositStatus === false) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h5"
          fontWeight={600}
          fontFamily="Aeonik"
          color="text.secondary"
        >
          This functionality is disabled.
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ width: "100%", height: "100vh" }}>
        <Box
          sx={{
            width: "100%",
            mt: 0,
            background: "#fff",
            borderRadius: "16px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <Box sx={{ justifyContent: "space-between", display: "flex", p: 2 }}>
            <Typography
              fontFamily={"Aeonik"}
              sx={{ fontSize: "24px", fontWeight: 700 }}
            >
              Bullion Deposit Plan
            </Typography>

         {canCreateBullionDeposit && ( <Button
              variant="contained"
              startIcon={<AddIcon />}
              sx={{
                textTransform: "none",
                background: "#7028DA",
                fontFamily: "inherit",
              }}
              onClick={handleOpenDialog}
            >
              Create New Plan{" "}
            </Button>)}  
          </Box>
          <CardContent
            sx={{
              height: "580px",
              width: "100%",
            }}
          >
            <BullionDepositList />
          </CardContent>
        </Box>

        <Dialog
          open={open}
          onClose={handleCloseDialog}
          fullWidth
          maxWidth="lg"
            PaperProps={{
          sx: {
            borderRadius: "3px",
           
          },
        }}
        >  <Box sx={{ overflowY: "auto", }}>
           <Box
                 sx={{
              position: "absolute",
              top: 10,
              right: 10,
              cursor: "pointer",
              background: "#E2E2EA",
              borderRadius: "50%",
              width: 26,
              height: 26,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#646464",
            }}
                onClick={handleCloseDialog}
              >
                <RxCross2 />
              </Box>
            </Box>

            <Typography
             fontWeight={700} fontSize={24}   p={2} mb={3} fontFamily={"Aeonik"}     sx={{
              background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
              color: "#fff",
            }}>
              Deposit Plan Details
            </Typography>
<Box sx={{p:1}}>
            <Grid container spacing={4} >
              <Grid item size={4}>
                <TextField
                  label={
                    <>
                      Plan Name <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  fullWidth
                 size="small"
                  placeholder="Enter Plan name"
                  name="planName"
                  value={formData.planName}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^[a-zA-Z\s]*$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                />
              </Grid>
              <Grid item size={4}>
                <TextField
                  label={
                    <>
                      Plan Quantity (Gms){" "}
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  placeholder="Enter plan quantity"
                 fullWidth
                  size="small"
                  name="planQuantity"
                  value={formData.planQuantity}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*\.?\d*$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                />
              </Grid>
              <Grid item size={4}>
                <TextField 
                fullWidth
                  label={
                    <>
                      Plan Duration (Days){" "}
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  placeholder="Enter Plan duration"
                  size="small"
                  name="planduration"
                  value={formData.planduration}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={4} mt={1}>
              <Grid item size={4}>
                <FormControl fullWidth size="small">
                  <InputLabel id="metal-label">
                    Select Metal <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="metal-label"
                   value={role}
                    onChange={(e) => setRole(e.target.value)}
                    label="Select Metal"
                  >
                    <MenuItem value="" disabled>
                      <em>Select Metal</em>
                    </MenuItem>
                    {enabledMetals
                      .filter((metal) => metal.status === true)
                      .map((metal) => (
                        <MenuItem key={metal._id} value={metal._id}>
                          {`${metal.metalName} - ${metal.karat}K - ${metal.purity}`}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item size={4}>
                <TextField
                  label={
                    <>
                      Plan Benefits/Annum{" "}
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  placeholder="Enter plan benefits"
                  fullWidth
                 size="small"
                  name="interest"
                  value={formData.interest}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*\.?\d*$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} mt={2}>
              <Grid item size={8}>
                <FormControl fullWidth>
                  <TextField
                    label={<>Enter Plan disclaimer </>}
                    multiline
                    minRows={3}
                    fullWidth
                    placeholder="Enter Plan disclaimer"
                    name="disclaimer"
                    value={formData.disclaimer}
                    onChange={handleChange}
                  />
                </FormControl>
              </Grid>
            </Grid>
/</Box>
            <DialogActions>
              <Button
                variant="contained"
                sx={{
                  background: "#7028DA",
                  px: 6,
                  textTransform: "none",
                }}
                onClick={handleAdd}
              >
                Save
              </Button>
            </DialogActions>
          
        </Dialog>
      </Box>
    </>
  );
};

export default BullionDeposit;
